import equal from 'Angular/utils/equal/deep-equal';
/**
 * Returns true if the item is shared with other users.
 * @param item serialized shareable item
 */
export const isSharedWithOthers = (item) => {
    return Boolean(item && item.sharing && item.sharing.is_owner && item.sharing.permission !== 'no_view');
};
/**
 * Returns the tooltip message to display, e.g. 'Shared (View) with YCharts Staff'.
 * If the client group name is long, the CSS will automatically split it across multiple lines.
 * @param item
 * @returns HTML string for the tooltip message
 */
export const getSharingTooltipMessage = (item) => {
    let sharingTooltipMessage = '';
    if (!item || !item.sharing) {
        return sharingTooltipMessage;
    }
    const { permission, client_group_name, client_group_id } = item.sharing;
    if (permission !== null && client_group_id !== null) {
        const formattedPermission = permission.charAt(0).toUpperCase() + permission.slice(1);
        sharingTooltipMessage = `<div class='multi-line-tooltip'>Shared (${formattedPermission}) with ${client_group_name}</div>`;
    }
    return sharingTooltipMessage;
};
export function isMinimalShareableItem(value) {
    return Object.prototype.hasOwnProperty.call(value, 'sharing') && equal(['type'], Object.keys(value.sharing));
}
/**
 * Returns the display name for the owner of a shareable item.
 * If the item is shared with a client group and the viewer is not the owner and the client group is not public,
 * it returns "owner_name - client_group_name". Otherwise, it returns just the owner_name.
 * @param param - sharing info of the item
 * @returns Owner display name
 */
export function getOwnerDisplayName({ is_owner, is_client_group_public, owner_name, client_group_name, }) {
    const displayClientGroup = Boolean(!is_owner && !is_client_group_public && client_group_name);
    return displayClientGroup ? `${owner_name} - ${client_group_name}` : owner_name;
}
